import * as React from "react";
function SvgCog(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      ref={svgRef}
      {...props}
    >
      <circle cx={16} cy={16} r={3} />
      <path d="M28.8 13.8l-3.32-1a10.16 10.16 0 00-1.87-3.3l.87-3.36a12.86 12.86 0 00-4-2.34L18 6.2a10 10 0 00-2-.2 9.83 9.83 0 00-1.81.17l-2.47-2.43A12.89 12.89 0 007.69 6l.82 3.39a9.92 9.92 0 00-1.92 3.26l-3.36.93A13.69 13.69 0 003 16a13.33 13.33 0 00.2 2.2l3.32 1a10.16 10.16 0 001.87 3.3l-.87 3.36a12.86 12.86 0 004 2.34L14 25.8a10 10 0 002 .2 9.83 9.83 0 001.81-.17l2.47 2.43a12.89 12.89 0 004-2.26l-.82-3.39a9.92 9.92 0 001.92-3.26l3.36-.93A13.69 13.69 0 0029 16a13.33 13.33 0 00-.2-2.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCog);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
